import { Check, XIcon } from 'lucide-react';

const SettingDisplay = ({
  id,
  label,
}: {
  id?: string | number;
  label: string;
}) => {
  return (
    <div className="mb-1">
      {id ? (
        <Check className="mr-1 inline text-green-500" size={16} />
      ) : (
        <XIcon className="mr-1 inline text-red-500" size={16} />
      )}
      <span className="font-medium">{label}</span>
    </div>
  );
};

export default SettingDisplay;
